import { lazy, Suspense } from "react";

import loadingWholeAppLottie from "assets/files/loading-whole-app-lottie.json";
import { ColorVariables, Paths, zIndexes } from "configs";
import Lottie from "lottie-react";
import { RouteProps } from "react-router-dom";

const FormLibraryPage = lazy(() => import("pages/FormLibrary"));

export const PublicSuspenseWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Suspense
    fallback={
      <Lottie
        animationData={loadingWholeAppLottie}
        style={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          zIndex: zIndexes.Lottie,
          backgroundColor: ColorVariables.White,
        }}
      />
    }
  >
    {children}
  </Suspense>
);

export const PublicRoutes: Array<
  RouteProps & {
    useSuspense?: boolean;
  }
> = [
  {
    path: `${Paths.Public.FormLibrary}/:linkPath`,
    index: true,
    element: <FormLibraryPage />,
    useSuspense: true,
  },
];
